module.exports = __webpack_public_path__ + "img/benkafa_thumb.8223b938.jpg";